(() => {
  const bar = document.getElementById('progress-bar');
  let ticking = false;
  function updateProgress() {
    const range = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = `${range > 0 ? Math.min(100, window.scrollY / range * 100) : 0}%`;
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateProgress);
      ticking = true;
    }
  }, { passive: true });
  updateProgress();

  const track = (name, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `cs_${name}`, cs_campaign: 'who-is-call-sign', cs_label: label });
    window.dispatchEvent(new CustomEvent('cs:track', { detail: { name, label } }));
  };
  track('lp_view', 'v2-editorial-preview');
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cs-event]');
    if (link) track(link.dataset.csEvent, link.dataset.csLabel || link.textContent.trim());
  });
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        track('reach', entry.target.id);
        observer.unobserve(entry.target);
      }
    }
  }, { threshold: 0.2 });
  document.querySelectorAll('[data-cs-view][id]').forEach(section => observer.observe(section));
  document.querySelector('.signup')?.addEventListener('submit', () => track('email_submit', 'footer-signup'));

  const archive = document.querySelector('.archive-track');
  const photos = [...document.querySelectorAll('.archive-item')];
  const lightbox = document.getElementById('archive-lightbox');
  if (archive && photos.length && lightbox) {
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    const current = document.getElementById('archive-current');
    const lightboxImage = document.getElementById('archive-lightbox-image');
    const lightboxCaption = document.getElementById('archive-lightbox-caption');
    const lightboxCount = document.getElementById('archive-lightbox-count');
    let selected = 0;
    let frame = 0;
    let opened = 0;

    function updateArchive() {
      const center = archive.getBoundingClientRect().left + archive.clientWidth / 2;
      let nearest = 0;
      let nearestDistance = Infinity;
      photos.forEach((photo, index) => {
        const rect = photo.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        const closeness = Math.max(0, 1 - distance / (rect.width * 1.8));
        photo.style.setProperty('--scale', (0.83 + closeness * 0.17).toFixed(3));
        photo.style.setProperty('--opacity', (0.58 + closeness * 0.42).toFixed(3));
        if (distance < nearestDistance) { nearestDistance = distance; nearest = index; }
      });
      selected = nearest;
      current.textContent = String(nearest + 1).padStart(2, '0');
      frame = 0;
    }
    function queueArchive() {
      if (!frame) frame = requestAnimationFrame(updateArchive);
    }
    function showPhoto(index) {
      opened = (index + photos.length) % photos.length;
      const source = photos[opened];
      const image = source.querySelector('img');
      lightboxImage.src = image.src;
      lightboxImage.alt = image.alt;
      lightboxCaption.textContent = source.dataset.caption || image.alt;
      lightboxCount.textContent = `${String(opened + 1).padStart(2, '0')} / ${String(photos.length).padStart(2, '0')}`;
      if (!lightbox.open) lightbox.showModal();
      track('archive_open', String(opened + 1));
    }
    archive.addEventListener('scroll', queueArchive, { passive: true });
    window.addEventListener('resize', queueArchive, { passive: true });
    archive.addEventListener('wheel', event => {
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX) || event.ctrlKey) return;
      const next = archive.scrollLeft + event.deltaY;
      if (next > 0 && next < archive.scrollWidth - archive.clientWidth) {
        event.preventDefault();
        archive.scrollLeft = next;
      }
    }, { passive: false });
    archive.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        photos[(selected + (event.key === 'ArrowRight' ? 1 : -1) + photos.length) % photos.length].scrollIntoView({ behavior: still.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
    });
    document.querySelector('.archive-prev').addEventListener('click', () => photos[Math.max(0, selected - 1)].scrollIntoView({ behavior: still.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }));
    document.querySelector('.archive-next').addEventListener('click', () => photos[Math.min(photos.length - 1, selected + 1)].scrollIntoView({ behavior: still.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }));
    photos.forEach((photo, index) => photo.addEventListener('click', () => showPhoto(index)));
    lightbox.querySelector('.archive-lightbox__close').addEventListener('click', () => lightbox.close());
    lightbox.querySelector('.archive-lightbox__prev').addEventListener('click', () => showPhoto(opened - 1));
    lightbox.querySelector('.archive-lightbox__next').addEventListener('click', () => showPhoto(opened + 1));
    lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
    lightbox.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showPhoto(opened - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showPhoto(opened + 1); }
    });
    let touchStart = null;
    lightbox.addEventListener('touchstart', event => { touchStart = event.touches[0]?.clientX ?? null; }, { passive: true });
    lightbox.addEventListener('touchend', event => {
      if (touchStart === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStart) - touchStart;
      if (Math.abs(distance) > 50) showPhoto(opened + (distance < 0 ? 1 : -1));
      touchStart = null;
    }, { passive: true });
    updateArchive();
  }

  const reviewTrack = document.querySelector('.review-grid');
  if (reviewTrack) {
    const cards = [...reviewTrack.querySelectorAll('blockquote')];
    const label = document.getElementById('review-current');
    let active = 0;
    let frame = 0;
    const update = () => {
      const left = reviewTrack.getBoundingClientRect().left;
      active = cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best, 0);
      label.textContent = String(active + 1).padStart(2, '0');
      frame = 0;
    };
    reviewTrack.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    const go = delta => cards[Math.max(0, Math.min(cards.length - 1, active + delta))].scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    document.querySelector('.review-prev')?.addEventListener('click', () => go(-1));
    document.querySelector('.review-next')?.addEventListener('click', () => go(1));
    reviewTrack.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1); }
    });
    update();
  }

  const ownerHover = document.getElementById('owner-hover');
  const ownerLightbox = document.getElementById('owner-lightbox');
  if (ownerHover && ownerLightbox) {
    const hoverImage = ownerHover.querySelector('img');
    const hoverCaption = ownerHover.querySelector('span');
    const fullImage = ownerLightbox.querySelector('figure img');
    const fullCaption = ownerLightbox.querySelector('figcaption');
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const hidePreview = () => {
      ownerHover.classList.remove('is-visible');
      ownerHover.setAttribute('aria-hidden', 'true');
    };
    document.querySelectorAll('.owner-gallery figure').forEach(figure => {
      const button = figure.querySelector('.owner-gallery__open');
      const image = button?.querySelector('img');
      const caption = figure.querySelector('figcaption')?.textContent.trim() || image?.alt;
      if (!button || !image) return;
      figure.addEventListener('mouseenter', () => {
        if (!canHover.matches || ownerLightbox.open) return;
        hoverImage.src = image.currentSrc || image.src;
        hoverImage.alt = image.alt;
        hoverCaption.textContent = caption;
        ownerHover.setAttribute('aria-hidden', 'false');
        ownerHover.classList.add('is-visible');
      });
      figure.addEventListener('mouseleave', hidePreview);
      button.addEventListener('click', () => {
        hidePreview();
        fullImage.src = image.currentSrc || image.src;
        fullImage.alt = image.alt;
        fullCaption.textContent = caption;
        ownerLightbox.showModal();
      });
    });
    ownerLightbox.querySelector('.owner-lightbox__close').addEventListener('click', () => ownerLightbox.close());
    ownerLightbox.addEventListener('click', event => { if (event.target === ownerLightbox) ownerLightbox.close(); });
    window.addEventListener('scroll', hidePreview, { passive: true });
  }
})();
